export function scrollToWithCallback(
  options: ScrollToOptions,
  callback?: () => void,
): void {
  if (typeof callback !== 'function') {
    window.scrollTo(options);
    return;
  }

  let lastScrollTop =
    document.documentElement.scrollTop || document.body.scrollTop;
  let stableCount = 0;

  const checkScrollEnd = () => {
    const currentScrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    if (Math.abs(currentScrollTop - lastScrollTop) < 1) {
      stableCount++;
      if (stableCount >= 3) {
        // Stable for 3 frames
        callback?.();
        return;
      }
    } else {
      stableCount = 0;
    }
    lastScrollTop = currentScrollTop;
    requestAnimationFrame(checkScrollEnd);
  };

  window.scrollTo(options);
  requestAnimationFrame(checkScrollEnd);
}
